module.exports = __webpack_public_path__ + "res/27-img_game_bg_t.63b7cd3f9d6dfbac16a61b9bb92f88fc.png";